module.exports = __webpack_public_path__ + "static/media/kt-logo.c85731e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/kt-logo.png
// module id = 563
// module chunks = 1